import React from "react";
import { Controller, Control } from "react-hook-form";
import { FormLabel } from "../../../components-new/utils";

interface TabOption {
    label: string;
    value: string;
    icon: string;
}

interface TabButtonGroupProps {
    name: string;
    label: string;
    options: TabOption[];
    control: Control<any>;
}

export const TabButtonGroup: React.FC<TabButtonGroupProps> = ({
    name,
    label,
    options,
    control,
}) => {
    return (
        <div>
            <FormLabel className="mb-3">{label}</FormLabel>
            <Controller
                name={name}
                control={control}
                render={({ field }) => (
                    <div className="flex items-center gap-2 border-b border-slate-200">
                        {options.map((option) => {
                            const isActive = field.value === option.value;
                            return (
                                <button
                                    key={option.value}
                                    type="button"
                                    onClick={() => field.onChange(option.value)}
                                    className={`inline-flex items-center gap-2 px-3.5 py-2 text-sm font-semibold transition-all whitespace-nowrap border-b-2 ${
                                        isActive
                                            ? "text-slate-900 border-slate-900"
                                            : "text-slate-600 border-transparent hover:text-slate-800 hover:border-slate-300"
                                    }`}
                                >
                                    <i
                                        className={`fas ${option.icon} text-xs ${
                                            isActive
                                                ? "text-slate-600"
                                                : "text-slate-500"
                                        }`}
                                    />
                                    {option.label}
                                </button>
                            );
                        })}
                    </div>
                )}
            />
        </div>
    );
};
